import './rejected.component.scss';

// @vendor
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// @components
import { OKLayoutMigration } from '../layout/OKLayoutMigration';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
import { recordLinkV2, recordProcess } from 'utilities/tagging';

// @constants
import { migrationKeys } from '../../migrationUsersBranchView.poeditor';
import { migrationRejectedKeys } from './rejected.component.poeditor';
import { catalogue, analyticsId } from './analytics/rejected.tracking';
import { MIGRATION_STATE } from '../../migrationUsersBranchView.constants';
import { rejectMigration } from '../../actions/migration';
import { CommonError } from '../commonError/commonError.component';

const rejectedImage = require('../../assets/miss-you.svg');
export const Rejected = ({ handleChangeMigrationState }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const dispatch = useDispatch();
  const history = useHistory();
  const immScreen = useSelector(state => state.screen);
  useEffect(() => {
    window.utag_last_name = '/migrationRejected';
    recordProcess(
      'proc-migracion',
      'migración rechazada',
      catalogue[analyticsId.REJECTED_VIEW](),
      true
    );
  }, []);

  const handleGoToPG = () => {
    if (immScreen.get('desktop')) {
      history.push('/myprofile/global');
    } else {
      window.location.href = '/myprofile/global/';
    }
  };

  const handlerRejectMigration = () => {
    if (error) {
      setError();
    }
    setLoading(true);
    recordLinkV2(catalogue[analyticsId.EXIT_BUTTON]());
    rejectMigration(dispatch)
      .then(() => handleGoToPG())
      .catch(error => setError(error))
      .finally(() => setLoading(false));
  };

  return (
    <OKLayoutMigration
      footer={
        error
          ? undefined
          : {
              leftSideLink: {
                disabled: loading,
                text: formatText(migrationKeys.goToMigrationButton),
                handler: () => {
                  recordLinkV2(catalogue[analyticsId.MIGRATE_LINK]());
                  handleChangeMigrationState(MIGRATION_STATE.TERMS_AND_CONDITIONS);
                },
              },
              rightSideButton: {
                disabled: loading,
                loading,
                text: formatText(migrationRejectedKeys.exitButton),
                handler: handlerRejectMigration,
              },
            }
      }
    >
      {error ? (
        <CommonError
          error={error?.error?.description?.description || error?.error?.description}
          handleOnClick={handlerRejectMigration}
        />
      ) : (
        <div>
          <div className="migration-rejected__image">
            <img src={rejectedImage} />
          </div>
          <div className="migration-rejected__title">
            <FormattedText value={migrationRejectedKeys.title} />
          </div>
          <div className="migration-rejected__description">
            {immScreen.get('isDesktop') ? (
              <FormattedText
                value={migrationRejectedKeys.description}
                injectedStrings={[formatText(migrationKeys.migrationPhone)]}
              />
            ) : (
              <FormattedText
                value={migrationRejectedKeys.mobileDescription}
                injectedStrings={[
                  `tel: ${formatText(migrationKeys.migrationPhone)}`,
                  formatText(migrationKeys.migrationPhone),
                ]}
              />
            )}
          </div>
        </div>
      )}
    </OKLayoutMigration>
  );
};

Rejected.propTypes = {
  handleExitLeaveModal: PropTypes.func.isRequired,
};
